import { Component, OnInit, Input, Output, EventEmitter, SimpleChange, Injector, ComponentFactoryResolver } from '@angular/core';
import { cloneDeep } from "lodash-es";
import { BsModalService, BsModalRef, ModalOptions } from '@farris/ui-modal';
import { IdService } from '@farris/ui-common';
import { PropertyItem, CommandItem } from '../events-editor.interface';
import { ViewModelComponent } from '../view-model/view-model.component';
import { EventsEditorUtil } from '../../events-editor-utils';
import { NotifyService } from '@farris/ui-notify';
import { AppNavigationSelectorComponent } from '@farris/app-navigation-selector';
import { FormBasicService, SchemaService } from '@farris/designer-services';
import { eventEditorLocale } from '../entity/locale';
@Component({
    selector: 'farris-command-source',
    templateUrl: './command-source.component.html',
    styleUrls: ['./command-source.component.css']
})

export class CommandSourceComponent implements OnInit {
    /** 中文或英文环境标识 */
    @Input() localeId: string;
    /** 当前显示的是第几个事件*/
    @Input() i: number;
    /** 入参 */
    @Input() initialData: any;
    /** 原层级结构数据 */
    @Input() originalData: any;
    /** 判断是否为新引入的方法 */
    @Input() newImport: boolean;
    /** 新增的内置构件列表 */
    @Input() addInternalCommandList: any;
    /** 外层传入数据 */
    @Input() outerLayerValue: any;
    /** 判断是否为：点击“导入此方法”后，绑定了新增值 */
    @Input() exist: number;
    /** 接收是否显示「可选择方法」功能 */
    @Input() haveBoundCommand: boolean;
    /** 新增方法列表值变化事件 */
    @Output() addInternalCommandListChanged = new EventEmitter<any>();
    /** 新引入值变化事件 */
    @Output() newImportChanged = new EventEmitter<any>();
    /** 传出用户选择绑定的方法 */
    @Output() currentCommandChanged = new EventEmitter<any>();
    /** 传出数据变化 */
    @Output() originalDataChanged = new EventEmitter<any>();
    /** 用户点击了方法来源的关闭按钮 */
    @Output() clickClose = new EventEmitter<any>();
    /** 判断是否为：点击“导入此方法”后，绑定了新增值*/
    @Output() existChanged = new EventEmitter<any>();
    /** 判断是否有新增方法*/
    @Output() newFucChanged = new EventEmitter<any>();
    /** 用户点击的命令 */
    selectedCommand: any;
    // 是否为运行时定制环境
    runtimeCustom: boolean = false;
    // 新增方法时对应的事件
    newFuncEvents: any;
    eventEditorLocale = eventEditorLocale;
    constructor(private modalService: BsModalService, private idService: IdService, private notifySer: NotifyService, private formBasicService: FormBasicService, private schemaService: SchemaService, public injector: Injector, private resolver: ComponentFactoryResolver) { }

    ngOnInit() {
        this.initialData['repititionCommand'] = [];
        // 判断当前环境
        this.runtimeCustom = this.initialData.envType == 'runtimeCustom' ? true : false;
    }

    ngOnChanges(changes: SimpleChange) {

    }

    /** 原始数据值变化事件 */
    public onOriginalDataChanged(value) {
        this.originalData = cloneDeep(value);
        this.originalDataChanged.emit(value);
    }

    /** 方法绑定-遍历判断当前的方法是否被其他事件绑定，若已绑定，则及时更新最新值； */
    public iterateBoundEvents(currentCommand) {
        this.originalData.forEach(originalDataItem => {
            if (originalDataItem.currentCommand.label == currentCommand.label) {
                originalDataItem.currentCommand = currentCommand;
            }
        });
        this.originalData = cloneDeep(this.originalData);
    }

    /** 方法去重*/
    public getUniqueCommand() {
        let webCmds = cloneDeep(this.initialData.newController);
        for (let i = 0; i < webCmds.length; i++) {
            for (let j = i + 1; j < webCmds.length; j++) {
                if (webCmds[i].Id == webCmds[j].Id) {
                    webCmds.splice(j, 1);
                    j--;
                }
            }
        }
        this.initialData.newController = cloneDeep(webCmds);
    }

    /** 方法绑定-替换用户选择绑定的变量 */
    public onCurrentCommandChanged(currentCommand) {
        //遍历判断当前的方法是否被其他事件绑定，若已绑定，则及时更新最新值；
        this.iterateBoundEvents(currentCommand);
        if (this.newImport == true) {
            this.saveInternals(currentCommand);
        }
        this.currentCommandChanged.emit(currentCommand);
    }

    /** 「引入控制器」-若引入的方法未被选用，则删除该控制器 */
    public saveInternals(currentCommand) {
        let vm = this.initialData.viewModelId.replace(/-/g, '').replace('component', '').replace('viewmodel', '');
        //去除最后的数字;
        let number = /[0-9]/g;
        let commandLabel = currentCommand.label.replace(new RegExp(vm, 'g'), '').replace(new RegExp(number, 'g'), '');
        if (this.newImport) {
            //若新增的方法没有被点击，则不保存此次新增的控制器；
            if (this.addInternalCommandList.controllerList) {
                this.addInternalCommandList.controllerList.forEach(controllerListItem => {
                    if (commandLabel.toLowerCase() == controllerListItem.label.toLowerCase()) {
                        this.exist += 1;
                        this.existChanged.emit(this.exist);
                    }
                });
                if (this.exist == 0) {
                    this.originalData.forEach(originalDataItem => {
                        originalDataItem.internalCommandList.pop();
                    });
                }
            }
        }
        this.newImport = false;
        this.newImportChanged.emit(this.newImport);
        this.originalDataChanged.emit(this.originalData);
    }

    /** 「引入控制器」-弹窗显示 */
    public openMetadataSelector() {
        const compFactory = this.resolver.resolveComponentFactory(AppNavigationSelectorComponent);
        //依赖注入
        const compRef = compFactory.create(this.injector);
        // 配置模态框参数
        compRef.instance.editorParams = {
            relativePath: this.formBasicService.formMetaBasicInfo.relativePath,
            envType: this.formBasicService.envType,
        }
        /** 弹窗相关设置 */
        const modalConfig: ModalOptions = {
            title: this.localeId == 'zh-CHS' ? '选择内置控制器' : this.localeId == 'en' ? 'Select Built-in Controller' : '選擇內置控制器',
            width: 900,
            height: 500,
            resizable: false,
            showButtons: false,
            showMaxButton: false,
            minWidth: 700,
            minHeight: 400,
        };
        let modalPanel: BsModalRef;
        modalPanel = this.modalService.show(compRef, modalConfig);
        modalPanel.content.closeModal.subscribe((data) => {
            modalPanel.close();
        });
        modalPanel.content.submitModal.subscribe(data => {
            this.importNewCommand(data);
            modalPanel.close();
        });
    }

    /** 「引入控制器」-方法绑定*/
    public importNewCommand(data) {
        const webCommand = JSON.parse(data['metadata']['content']);
        // 存储所有用户新增的控制器
        this.initialData.newController.push(cloneDeep(webCommand));
        this.getUniqueCommand();
        const content = cloneDeep(webCommand);
        const importData = {
            /** 控制器名称 */
            controllerName: {
                id: content.Id,
                /** 控制器编号 */
                label: content.Code,
                /**控制器中文名 */
                name: content.Name,
                code: data['metadata'].code,
                nameSpace: data['metadata'].nameSpace
            },
            /** 当前控制器下的方法列表 */
            controllerList: [
            ],
        }
        if (content.Commands) {
            content.Commands.forEach(commandsItem => {
                let controllerListItem: CommandItem = {
                    label: commandsItem.Code,
                    name: commandsItem.Name,
                    id: commandsItem.Id,
                    handlerName: commandsItem.Code,
                    targetComponent: undefined,
                    hasPath: false,
                    cmpId: '',
                    componentLists: [],
                    shortcut: {},
                    // true：表明为新增项，可以编辑
                    isRTCmd: commandsItem['isRTCmd'],
                    isNewGenerated: commandsItem['isNewGenerated'] || false,
                    extensions: [],
                    isInvalid: false,
                    property: [],
                }
                if (!commandsItem.Parameters) {
                    commandsItem['Parameters'] = [];
                    controllerListItem.property = [];
                }
                commandsItem.Parameters.forEach(parameterItem => {
                    let propertyItem: PropertyItem = {
                        name: parameterItem.Code,
                        value: '',
                        shownName: parameterItem.Name,
                        description: parameterItem.Description,
                        id: '',
                        editorType: '',
                        isRetVal: false,
                        parameterType: '',
                        origin: cloneDeep(parameterItem)
                    }
                    controllerListItem.property.push(cloneDeep(propertyItem));
                });
                importData.controllerList.push(cloneDeep(controllerListItem));
            });
            // 检测新增的控制器不存在于原internals中
            let checkExist = 0;
            this.originalData[0].internalCommandList.forEach(internalCommandListItem => {
                if (internalCommandListItem.controllerName.label == importData.controllerName.label) {
                    checkExist += 1;
                }
            });
            if (checkExist == 0) {
                this.addInternalCommandList = cloneDeep(importData);
                this.addInternalCommandListChanged.emit(this.addInternalCommandList);
                this.originalData.forEach(originalDataItem => {
                    originalDataItem.internalCommandList.push(cloneDeep(this.addInternalCommandList));
                });
                this.newImport = true;
                this.exist = 0;
                this.existChanged.emit(this.exist)
                this.newImportChanged.emit(this.newImport);
            } else {
                const info = eventEditorLocale[this.localeId].eventsEditor.controllerExist;
                this.notifySer['info'](info);
            }
        }
    }

    /** 「编写新方法」-跳转至代码编辑器 */
    public generateNewFunc() {
        this.initialData.neFuncEvents = undefined;
        this.initialData.newFuncEvents = cloneDeep(this.originalData[this.i].events);
        this.initialData.isAddControllerMethod = true;
        // this.onOriginalDataChanged(this.originalData);

        // 通过回调函数，获取新方法；若没有返回值，则继续赋值，若有返回值，则直接使用返回值
        // this.initialData.getFuncCommand();

        this.originalData[this.i].currentCommand = {
            id: 'abandoned',
            code: this.localeId == 'zh-CHS' ? '未绑定方法' : this.localeId == 'en' ? 'No Bound Method' : '未綁定方法',
            label: this.localeId == 'zh-CHS' ? '未绑定方法' : this.localeId == 'en' ? 'No Bound Method' : '未綁定方法',
            name: this.localeId == 'zh-CHS' ? '未绑定方法' : this.localeId == 'en' ? 'No Bound Method' : '未綁定方法',
            params: [],
            handlerName: this.localeId == 'zh-CHS' ? '未绑定方法' : this.localeId == 'en' ? 'No Bound Method' : '未綁定方法',
            cmpId: '',
            shortcut: {},
            isRTCmd: undefined,
            isNewGenerated: undefined,
            extensions: [],
            isInvalid: false
        }
        this.originalData[this.i].currentControllerName = {
            label: '',
            name: '',
            id: '',
        };

        this.newFucChanged.emit();
        this.closeCurrentCommandModal();
    }

    /** 「已有方法」-弹窗显示 */
    public showBoundEvents() {
        /** 弹窗相关设置 */
        const modalConfig: ModalOptions = {
            width: 900,
            height: 500,
            title: this.localeId == 'zh-CHT' ? '已有方法' : this.localeId == 'en' ? 'Saved Methods' : '已有方法',
            minWidth: 700,
            minHeight: 400,
            buttons: [
                {
                    text: this.localeId == 'zh-CHT' ? '取消' : this.localeId == 'en' ? 'Cancel' : '取消',
                    cls: 'btn btn-secondary',
                    handle: () => {
                        modalPanel.close();
                    }
                },
                {
                    text: this.localeId == 'zh-CHT' ? '確定' : this.localeId == 'en' ? 'OK' : '确定',
                    cls: 'btn btn-primary',
                    handle: () => {
                        this.initialData.viewModel = cloneDeep(modalPanel.content.viewModel);
                        this.setSelectedCommand(modalPanel.content.selectedCommand);
                        if (modalPanel.content.selectedCommand != undefined && modalPanel.content.selectedCommand.active == true) {
                            modalPanel.close();
                        }
                    }
                }
            ]
        };
        let modalPanel: BsModalRef;
        modalConfig.initialState = {
            initialState: this.initialData,
        }
        modalPanel = this.modalService.show(ViewModelComponent, modalConfig);
        modalPanel.content.close.subscribe(() => {
            modalPanel.close();
        });
        modalPanel.content.submit.subscribe(() => {
            modalPanel.close();
        });
    }

    /** 「已有方法」-选择方法 */
    public setSelectedCommand(selectedCommand) {
        if (selectedCommand == undefined || selectedCommand.active == false) {
            const info = eventEditorLocale[this.localeId].eventsEditor.chooseSelect;
            this.notifySer['info'](info);
        }
        else {
            //绑定暂未绑定的命令时，自动默认当前组件下的当前事件
            selectedCommand['event'] = !selectedCommand['event']['label'] ? cloneDeep(this.originalData[this.i].events) : selectedCommand['event'];
            let commandExist = false;
            this.initialData.repititionCommand.forEach(repititionCommandItem => {
                //确保用户点击的方法在存储时不重复
                if (repititionCommandItem.command.id == selectedCommand.command.id && repititionCommandItem.event.label == selectedCommand.event.label && repititionCommandItem.targetComponent.viewModelId == selectedCommand.targetComponent.viewModelId) {
                    commandExist = true;
                }
                if (repititionCommandItem.command.id == selectedCommand.command.id && repititionCommandItem.event.label == selectedCommand.event.label && repititionCommandItem.targetComponent.viewModelId != selectedCommand.targetComponent.viewModelId) {
                    // 仅修改了目标组件值，则替换
                    repititionCommandItem = cloneDeep(selectedCommand);
                }
            });
            //没有点击过该方法,则增加
            if (!commandExist) {
                this.initialData.repititionCommand.push(cloneDeep(selectedCommand))
            }
            let newCommand = {
                id: selectedCommand.command.id,
                label: selectedCommand.command.label,
                name: selectedCommand.command.name,
                handlerName: selectedCommand.command.handlerName,
                cmpId: selectedCommand.controller.id,
                componentLists: [],
                hasPath: false,
                // targetComponent示例：root-component
                targetComponent: selectedCommand.targetComponent.id,
                property: cloneDeep(selectedCommand.command.params),
                shortcut: {},
                isRTCmd: selectedCommand['isRTCmd'],
                isNewGenerated: selectedCommand.command['isNewGenerated'] || false,
                extensions: [],
                isInvalid: false,
            }
            let controller = {
                controllerName: selectedCommand.controller
            }
            newCommand = EventsEditorUtil.setComponentLists(controller, newCommand, this.initialData);
            this.originalData[this.i].currentCommand = cloneDeep(newCommand);
            this.originalData[this.i].currentControllerName = cloneDeep(selectedCommand.controller);
            this.onCurrentCommandChanged(newCommand);
            this.onOriginalDataChanged(this.originalData);
            this.clickClose.emit();
        }

    }

    /** 「取消」-关闭浮层 */
    public closeCurrentCommandModal() {
        this.clickClose.emit();
        if (this.newImport) {
            //若新增方法后，直接点击取消，则回退一位；
            if (this.exist == 0) {
                this.originalData.forEach(element => {
                    element.internalCommandList.pop();
                })
                this.exist += 1;
                this.existChanged.emit(this.exist);
            }
        }
    }




}
